var moduleMap = {
	"./utils": () => {
		return __webpack_require__.e(427).then(() => (() => ((__webpack_require__(7427)))));
	},
	"./Typography": () => {
		return __webpack_require__.e(777).then(() => (() => ((__webpack_require__(777)))));
	},
	"./Toast": () => {
		return __webpack_require__.e(769).then(() => (() => ((__webpack_require__(6150)))));
	},
	"./kDesignStyle": () => {
		return Promise.all([__webpack_require__.e(987), __webpack_require__.e(587)]).then(() => (() => ((__webpack_require__(4587)))));
	},
	"./KDesign": () => {
		return Promise.all([__webpack_require__.e(119), __webpack_require__.e(496), __webpack_require__.e(450), __webpack_require__.e(783), __webpack_require__.e(555), __webpack_require__.e(25)]).then(() => (() => ((__webpack_require__(2574)))));
	},
	"./KContext": () => {
		return Promise.all([__webpack_require__.e(119), __webpack_require__.e(496), __webpack_require__.e(783), __webpack_require__.e(499), __webpack_require__.e(150)]).then(() => (() => ((__webpack_require__(3150)))));
	},
	"./KHooks": () => {
		return Promise.all([__webpack_require__.e(119), __webpack_require__.e(496), __webpack_require__.e(783), __webpack_require__.e(555), __webpack_require__.e(499), __webpack_require__.e(9)]).then(() => (() => ((__webpack_require__(28)))));
	},
	"./AuthComponent": () => {
		return Promise.all([__webpack_require__.e(119), __webpack_require__.e(783), __webpack_require__.e(758)]).then(() => (() => ((__webpack_require__(7758)))));
	},
	"./icons": () => {
		return __webpack_require__.e(545).then(() => (() => ((__webpack_require__(9545)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});